import sumBy from 'lodash/sumBy';
import type { OnlineStudySubject } from '../../ViewModel/Subjects/OnlineStudySubject.csharp';
import type { Money } from '~/Features/Money.csharp';
import type { IParentItem, OnlineApplicationChoice } from '~/Features/OnlineApplication/Model';

export const GetSubjectsTotalPrice = (
    subjects: OnlineStudySubject[],
    currencyCode = 'NOK',
    currencySymbol = 'kr'
): Money => {
    const totalPrice = sumBy(subjects, subject => subject.price.amount);

    return {
        currencyCode,
        currencySymbol,
        amount: totalPrice,
    };
};

export const GetSubjectsTotalPoints = (subjects: OnlineStudySubject[]) =>
    subjects.map(s => s.credits).reduce((p, c) => p + c, 0);

export const GetCreditsLabel = (subjects: OnlineStudySubject[]) => (subjects[0] ? subjects[0].creditsLabel : '');

export const ChoiceEqualsChoice = (choice1: OnlineApplicationChoice, choice2: OnlineApplicationChoice) =>
    choice1.subject.code === choice2.subject.code &&
    choice1.parentStudy.code === choice2.parentStudy.code &&
    ParentItemEqualsParentItem(choice1.parentItem, choice2.parentItem);

const arePartTimeSubjectsEqualToSingleSubjects = false;
export const ParentItemEqualsParentItem = (parentItem1?: IParentItem, parentItem2?: IParentItem) => {
    if (!parentItem1 && !parentItem2) {
        return true;
    }

    if (!parentItem1 || !parentItem2) {
        return arePartTimeSubjectsEqualToSingleSubjects;
    }

    return parentItem1.semesterIndex === parentItem2.semesterIndex && parentItem1.itemIndex === parentItem2.itemIndex;
};

export const IsChoiceAddedToBasket = (choicesFromBasket: OnlineApplicationChoice[], choice: OnlineApplicationChoice) =>
    choicesFromBasket.some(choiceFromBasket => ChoiceEqualsChoice(choice, choiceFromBasket));
